@if (variant() === 'parent') {
  <div
    class="course-card course-card--parent"
    [class.course-card--draft]="isDraft()"
    [class.course-card--parent-in-progress]="parentCardState() === 'in-progress'"
    [class.course-card--parent-completed]="parentCardState() === 'completed'"
  >
    <div
      class="course-card__parent-cover"
      [class.course-card__parent-cover--placeholder]="!displayImageUrl()"
      [attr.data-difficulty]="getIconColor(displayDifficulty())"
    >
      @if (displayImageUrl()) {
        <img
          class="course-card__parent-cover-image"
          [src]="displayImageUrl()"
          [alt]=""
        />
      } @else if (!isDraft()) {
        <img
          class="course-card__parent-cover-fallback"
          [src]="getFaceImage(displayDifficulty())"
          alt=""
        />
      } @else {
        <img
          class="course-card__parent-cover-fallback"
          src="/public/svgs/edit.svg"
          alt=""
        />
      }
      @if (parentCardState() === 'completed') {
        <span class="course-card__parent-completed-badge">
          {{ 'app.components.courseCard.completed' | translate }}
        </span>
      }
    </div>
    <div class="course-card__parent-body">
      @if (isDraft()) {
        <span class="course-card__parent-status">
          {{ ('app.components.courseCard.' + status()?.toLowerCase()) | translate }}
        </span>
      }
      <div class="course-card__parent-title-row">
        <div class="course-card__parent-title">{{ displayTitle() }}</div>
        @if (parentCardState() === 'in-progress') {
          <span class="course-card__parent-continue">
            {{ 'app.components.courseCard.continue' | translate }}
          </span>
        }
      </div>
      @if (!isDraft() && displayDescription()) {
        <p class="course-card__parent-description">{{ displayDescription() }}</p>
      }
      @if (showParentProgress()) {
        <app-parent-learn-progress
          [inline]="true"
          [percent]="displayPercent()"
          [completedCount]="displayCompletedTaskCount()"
          [totalCount]="displayTaskCount()"
        />
      }
      @if (parentBadges().length > 0) {
        <div class="course-card__parent-meta">
          @for (badge of parentBadges(); track badge.value + (badge.iconUrl ?? '') + (badge.tagColor ?? '')) {
            <app-card-badge
              [value]="badge.value"
              [iconUrl]="badge.iconUrl"
              [translateKey]="badge.translateKey ?? false"
              [variant]="badge.variant ?? 'metric'"
              [tagColor]="badge.tagColor"
            />
          }
        </div>
      }
    </div>
    @if (isCourseDraft()) {
      <div class="course-card__spinner" aria-hidden="true">
        <div class="course-card__spinner-inner"></div>
      </div>
    }
  </div>
} @else {
  <div class="course-card" [class.course-card--highlighted]="true" [class.course-card--draft]="isDraft()">
    <div class="course-card__content">
      <div class="course-card__badges">
        @for (badge of badges(); track badge.value + (badge.iconUrl ?? '') + (badge.tagColor ?? '')) {
          <app-card-badge
            [value]="badge.value"
            [iconUrl]="badge.iconUrl"
            [translateKey]="badge.translateKey ?? false"
            [variant]="badge.variant ?? 'metric'"
            [tagColor]="badge.tagColor"
          />
        }
      </div>
      <div class="course-card__top">
        <div class="course-card__icon" [class.course-card__icon--cover]="displayImageUrl()">
          <div
            class="icon-badge"
            [ngClass]="[
              isDraft() ? 'icon-badge--gray' : 'icon-badge--' + getIconColor(displayDifficulty()),
              displayImageUrl() && 'icon-badge--cover',
            ]"
          >
            <div class="icon-badge__inner">
              @if (isDraft()) {
                <img src="/public/svgs/edit.svg" alt="Draft" class="icon-badge__image" />
              } @else if (displayImageUrl()) {
                <img
                  [src]="displayImageUrl()"
                  [alt]="displayTitle()"
                  class="icon-badge__image icon-badge__image--cover"
                />
              } @else {
                <img
                  [src]="getFaceImage(displayDifficulty())"
                  [alt]="'Difficulty: ' + (displayDifficulty() ?? '')"
                  class="icon-badge__image"
                />
              }
            </div>
          </div>
        </div>
        @if (isDraft()) {
          <div class="course-card__draft-badge">
            <span class="course-card__draft-badge-text">
              {{ ('app.components.courseCard.' + status()?.toLowerCase()) | translate }}
            </span>
          </div>
        }
      </div>
      <div class="course-card__body">
        <div class="course-card__title">{{ displayTitle() }}</div>
        @if (!isDraft()) {
          <div class="course-card__description">{{ displayDescription() }}</div>
        }
      </div>
    </div>
    @if (isCourseDraft()) {
      <div class="course-card__spinner" aria-hidden="true">
        <div class="course-card__spinner-inner"></div>
      </div>
    }
  </div>
}
